import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "presence-form__row" }
const _hoisted_2 = { class: "presence-form__field" }
const _hoisted_3 = {
  key: 0,
  class: "presence-form__error"
}
const _hoisted_4 = { class: "presence-form__field" }
const _hoisted_5 = {
  key: 0,
  class: "presence-form__error"
}
const _hoisted_6 = { class: "presence-form__checkboxes" }
const _hoisted_7 = { class: "presence-form__checkbox-item" }
const _hoisted_8 = { class: "presence-form__checkbox-item" }
const _hoisted_9 = { class: "presence-form__checkbox-item" }
const _hoisted_10 = { class: "presence-form__checkbox-item" }
const _hoisted_11 = {
  key: 0,
  class: "presence-form__error presence-form__error--centered"
}
const _hoisted_12 = { class: "presence-form__field" }
const _hoisted_13 = { class: "presence-form__submit" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["Form"], {
    resolver: $setup.resolver,
    class: "presence-form",
    onSubmit: $setup.onFormSubmit
  }, {
    default: _withCtx(() => [
      _cache[14] || (_cache[14] = _createElementVNode("p", { class: "presence-form__intro" }, " Merci de nous indiquer si vous serez des nôtres pour célébrer ce jour si spécial. ", -1 /* CACHED */)),
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "presence-form__divider" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["FloatLabel"], { variant: "on" }, {
            default: _withCtx(() => [
              _createVNode($setup["InputText"], {
                id: "first_name",
                name: "first_name",
                "model-value": $props.modelValue.first_name,
                invalid: $setup.submitted && !$props.modelValue.first_name,
                fluid: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => $setup.updateModel('first_name', value))
              }, null, 8 /* PROPS */, ["model-value", "invalid"]),
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "first_name" }, "Prénom", -1 /* CACHED */))
            ]),
            _: 1 /* STABLE */
          }),
          ($setup.submitted && !$props.modelValue.first_name)
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, " Merci de renseigner votre prénom "))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["FloatLabel"], { variant: "on" }, {
            default: _withCtx(() => [
              _createVNode($setup["InputText"], {
                id: "last_name",
                name: "last_name",
                "model-value": $props.modelValue.last_name,
                invalid: $setup.submitted && !$props.modelValue.last_name,
                fluid: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => $setup.updateModel('last_name', value))
              }, null, 8 /* PROPS */, ["model-value", "invalid"]),
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "last_name" }, "Nom", -1 /* CACHED */))
            ]),
            _: 1 /* STABLE */
          }),
          ($setup.submitted && !$props.modelValue.last_name)
            ? (_openBlock(), _createElementBlock("small", _hoisted_5, " Merci de renseigner votre nom "))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "presence-form__divider" }, null, -1 /* CACHED */)),
      _cache[17] || (_cache[17] = _createElementVNode("p", { class: "presence-form__label" }, " Je serai présent(e) pour… ", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode($setup["Checkbox"], {
            "input-id": "secular_ceremony",
            "model-value": $props.modelValue.secular_ceremony_presence,
            binary: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => $setup.onPresenceChange('secular_ceremony_presence', value))
          }, null, 8 /* PROPS */, ["model-value"]),
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            for: "secular_ceremony",
            class: "presence-form__checkbox-label"
          }, " La cérémonie laïque ", -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode($setup["Checkbox"], {
            "input-id": "dinner",
            "model-value": $props.modelValue.dinner_presence,
            binary: "",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => $setup.onPresenceChange('dinner_presence', value))
          }, null, 8 /* PROPS */, ["model-value"]),
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "dinner",
            class: "presence-form__checkbox-label"
          }, " Le dîner ", -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode($setup["Checkbox"], {
            "input-id": "sunday_brunch",
            "model-value": $props.modelValue.sunday_brunch_presence,
            binary: "",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => $setup.onPresenceChange('sunday_brunch_presence', value))
          }, null, 8 /* PROPS */, ["model-value"]),
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "sunday_brunch",
            class: "presence-form__checkbox-label"
          }, " Le brunch du dimanche ", -1 /* CACHED */))
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "presence-form__divider" }, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_10, [
          _createVNode($setup["Checkbox"], {
            "input-id": "is_absent",
            "model-value": $props.modelValue.is_absent,
            binary: "",
            "onUpdate:modelValue": $setup.onAbsentChange
          }, null, 8 /* PROPS */, ["model-value"]),
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            for: "is_absent",
            class: "presence-form__checkbox-label"
          }, " Je ne pourrai pas être présent(e) ", -1 /* CACHED */))
        ])
      ]),
      ($setup.submitted && !$setup.hasAtLeastOneCheckbox)
        ? (_openBlock(), _createElementBlock("small", _hoisted_11, " Merci de cocher au moins une case "))
        : _createCommentVNode("v-if", true),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "presence-form__divider" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_12, [
        _createVNode($setup["FloatLabel"], { variant: "on" }, {
          default: _withCtx(() => [
            _createVNode($setup["Textarea"], {
              id: "diet_indications",
              name: "diet_indications",
              "model-value": $props.modelValue.diet_indications,
              rows: "3",
              fluid: "",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = (value) => $setup.updateModel('diet_indications', value))
            }, null, 8 /* PROPS */, ["model-value"]),
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "diet_indications" }, "Allergies ou régime alimentaire particulier", -1 /* CACHED */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode($setup["Button"], {
          type: "submit",
          loading: $setup.loading,
          class: "presence-form__button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.buttonLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["loading"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}